import { jsx as e } from "react/jsx-runtime";
import a from "../../Icons/Close.js";
import { ClearIndicatorWrapper as l } from "../styled.js";
const d = ({ onClear: i = () => {
}, value: r }) => ({ innerProps: o }) => {
  let t;
  return Array.isArray(r) ? t = r.length > 0 : t = !!r.value, t ? /* @__PURE__ */ e(l, { role: "button", ...o, onClick: i, children: /* @__PURE__ */ e(a, { height: "18px", width: "18px" }) }) : /* @__PURE__ */ e("div", { ...o });
};
export {
  d as default
};
